import React from "react";
import { useNavigate } from "react-router-dom";
import { Navbar, NavDropdown, Nav } from "react-bootstrap";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
// includes
import { common } from "helpers";

const InnerHeader = (props) => {
  // props
  const { handleDrawer, open, isMobile } = props;
  const navigate = useNavigate();
  // functions
  const onLogout = (e) => {
    e.preventDefault();
    localStorage.clear();
    common.localRemove("adminAuthData");
    navigate("/login");
  };
  // render
  return (
    <header className="header">
      <div className="container-fluid">
        <Navbar className="header-nav-wrap" expand={true} sticky="top">
          <div className="header-left">
            <button
              type="button"
              className="btn btn-toggle"
              onClick={handleDrawer}
              aria-label={open ? "Close menu" : "Open menu"}
            >
              {isMobile && open ? <CloseIcon /> : <MenuIcon />}
            </button>
            <Navbar.Brand href="#">
              <img
                src={common.cloudImg("media/us_tiny.png")}
                alt=""
                className="header-logo me-2"
              />
              <span>Admin</span>
            </Navbar.Brand>
          </div>
          <Nav className="ms-auto header-user-nav">
            <Nav.Item className="nav2-padding">
              <NavDropdown
                align="end"
                title={
                  <div className="login-user-info">
                    <div className="d-flex align-items-center border-disable">
                      <div className="me-3 me-md-5 header-welcome-text">
                        <h6 className="d-flex justify-content-start header1-welcome p-0 mb-0">
                          Welcome
                        </h6>
                        <p className="d-flex justify-content-start profile-name-text p-0 me-2 mb-0">
                          Admin
                        </p>
                      </div>

                      <img
                        src={common.loadImg("user-icon.svg")}
                        alt="userimage"
                        className="me-2"
                      />
                      <span>
                        <img
                          src={common.loadImg("down-arrow.svg")}
                          alt=""
                        />
                      </span>
                    </div>
                  </div>
                }
                id="collasible-nav-dropdown"
                className="custom-arrow-dropdown"
              >
                <NavDropdown.Item onClick={onLogout}>Logout</NavDropdown.Item>
              </NavDropdown>
            </Nav.Item>
          </Nav>
        </Navbar>
      </div>
    </header>
  );
};

export default InnerHeader;
